import { storageKeys } from './services/api';
import { storage } from './services/storage';

export type PerfilUsuario =
  | 'SOLICITANTE'
  | 'APROVADOR'
  | 'COMPRADOR'
  | 'FIEL_ARMAZEM'
  | 'GERENTE_EMPRESA'
  | 'FORNECEDOR'
  | 'SUPER_ADMIN'
  | 'ADMIN_SAAS'
  | 'ANALISTA_CANDIDATURAS'
  | 'ANALISTA_FINANCEIRO'
  | 'SUPORTE';

export type Operacao =
  | 'dashboard.visualizar'
  | 'requisicoes.visualizar'
  | 'requisicoes.criar'
  | 'aprovacoes.visualizar'
  | 'aprovacoes.decidir'
  | 'comprador.visualizar'
  | 'comprador.fecharCompra'
  | 'armazem.visualizar'
  | 'armazem.receber'
  | 'fornecedores.visualizar'
  | 'fornecedores.vinculos'
  | 'equipa.visualizar'
  | 'subscricao.visualizar'
  | 'feedback.visualizar'
  | 'comunicacoes.visualizar'
  | 'fornecedor.portal'
  | 'fornecedor.proposta'
  | 'admin.visualizar';

const todosInternos: PerfilUsuario[] = [
  'SOLICITANTE',
  'APROVADOR',
  'COMPRADOR',
  'FIEL_ARMAZEM',
  'GERENTE_EMPRESA'
];

export const perfisAdministrativos: PerfilUsuario[] = [
  'SUPER_ADMIN',
  'ADMIN_SAAS',
  'ANALISTA_CANDIDATURAS',
  'ANALISTA_FINANCEIRO',
  'SUPORTE'
];

const permissoes: Record<Operacao, PerfilUsuario[]> = {
  'dashboard.visualizar': todosInternos,
  'requisicoes.visualizar': todosInternos,
  'requisicoes.criar': ['SOLICITANTE'],
  'aprovacoes.visualizar': ['APROVADOR', 'GERENTE_EMPRESA'],
  'aprovacoes.decidir': ['APROVADOR'],
  'comprador.visualizar': ['COMPRADOR'],
  'comprador.fecharCompra': ['COMPRADOR'],
  'armazem.visualizar': ['FIEL_ARMAZEM'],
  'armazem.receber': ['FIEL_ARMAZEM'],
  'fornecedores.visualizar': ['GERENTE_EMPRESA'],
  'fornecedores.vinculos': ['GERENTE_EMPRESA'],
  'equipa.visualizar': ['GERENTE_EMPRESA'],
  'subscricao.visualizar': ['GERENTE_EMPRESA'],
  'feedback.visualizar': [...todosInternos, 'SUPER_ADMIN'],
  'comunicacoes.visualizar': [...todosInternos, 'FORNECEDOR'],
  'fornecedor.portal': ['FORNECEDOR'],
  'fornecedor.proposta': ['FORNECEDOR'],
  'admin.visualizar': perfisAdministrativos
};

export const perfilPode = (perfil: string | undefined | null, operacao: Operacao) =>
  Boolean(perfil && permissoes[operacao].includes(perfil as PerfilUsuario));

let usuarioCache: any = null;

export const carregarUsuarioSessao = async () => {
  const dados = await storage.getItem(storageKeys.usuario);
  usuarioCache = dados ? JSON.parse(dados) : null;
};

export const obterUsuarioSessao = () => usuarioCache;

export const obterPerfilSessao = () => obterUsuarioSessao()?.perfil as PerfilUsuario | undefined;


export const perfisDaOperacao = (operacao: Operacao) => permissoes[operacao];

export const perfilAdministrativo = (perfil: string | undefined | null) =>
  Boolean(perfil && perfisAdministrativos.includes(perfil as PerfilUsuario));
